import common from '@/common';
import { request } from '@umijs/max';

// 查询企业客户下的根账户
export async function getRootAcctService(params: any) {
  const { custcode, ...restParams } = params;
  return request(`/bcare/accts/root/${custcode}`, {
    params: restParams,
  });
}

// 查询企业客户所有账户
export async function getAllAccountService(params: any) {
  const { custcode, ...restParams } = params;
  return request(`/bcare/accts/search/${custcode}`, {
    params: restParams,
  });
}

// 查询账户详情
export async function getAcctDetailService(params: any) {
  // 针对 bcarefront_pto
  const { projectCode = '' } = common;
  if (projectCode === 'pto') {
    return request(`/bcare/PTO/accts/detail/${params.acctId}`);
  }
  return request(`/bcare/accts/detail/${params.acctId}`);
}

// 获取面板内可配置项
export async function getAttrInfoService() {
  return request('/bcare/accts/attr').then(
    (res) => res.acctAttrList || res?.attrs,
  );
}

// 查询billing cycle type
export async function getBillingCycleTypeService(params: any) {
  return request(`/bcare/table/column?tableName=${params.billingCycleType}`);
}

// bill Format
export async function getBillFormatService() {
  return request('/bcare/bill/format').then((res) => {
    if (res?.billFormatList?.length) {
      return (res?.billFormatList || [])?.map((item: any) => ({
        ...item,
        label: item.billFormatName,
        value: item.billFormatId,
      }));
    }
    return [];
  });
}

// 查询语言
export async function getLanguageListService() {
  return request('/bcare/member/language/list').then((res) => {
    if (res?.defLangList?.length) {
      return (res?.defLangList || [])?.map((item: any) => ({
        ...item,
        label: item.defLangName,
        value: item.defLangId,
      }));
    }
    return [];
  });
}

// 新增账户信息
export async function addAcctService(data: any) {
  return request('/bcare/accts/add', {
    method: 'POST',
    data,
  });
}

// 修改账户信息
export async function modifyAcctService(data: any) {
  return request('/bcare/accts/mod', {
    method: 'POST',
    data,
  });
}

// 查询账户
export async function searchAcctInfoService(params: any) {
  return request(`/bcare/accts/detail/condition`, {
    params,
  });
}

// um 查询地址 /bcare/um/address/qryAddrByPostCode
export async function queryAddressService(data: any) {
  return request('/bcare/um/address/qryAddrByPostCode', {
    method: 'POST',
    data,
  });
}

// 查询autopay账户
export async function searchAutopayList(params: {acctId:number, state: string}) {
  return request(`/bcare/autopay/list`, {
    params,
  });
}

// 查询签约状态
export async function searchAutopaySignState(params: {acctId:number}) {
  return request(`/bcare/autopay/checksigning`, {
    params,
  });
}

// 获取签约页面
export async function autopaySignin(data: {custName:string,partyCode:string,partyType:string,acctNbr:string,acctId:number, returnUrl?:string}) {
  return request('/bcare/autopay/sign', {
    method: 'POST',
    data,
  });
}

// 轮询查签约状态
export async function getSignResultService(params: any) {
  return request(`/bcare/autopay/result`, {
    params,
  });
}

// 取消签约
export async function autopayCancel(data: {custName:string,partyCode:string,partyType:string,acctNbr:string,acctId:number,mandateId:any,cancelAuthorInfo:any,authorizationCode:any}) {
  return request('/bcare/autopay/cancel', {
    method: 'POST',
    data,
  });
}

// 修改签约
export async function autopayModify(data: {custName:string,partyCode:string,partyType:string,acctNbr:string,acctId:number,mandateId:any,cancelAuthorInfo:any,authorizationCode:any}) {
  return request('/bcare/autopay/modify', {
    method: 'POST',
    data,
  });
}